import { render, staticRenderFns } from "./safetyHealthObliManage.vue?vue&type=template&id=6f1b0e4c"
import script from "./safetyHealthObliManage.vue?vue&type=script&lang=js"
export * from "./safetyHealthObliManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1b0e4c')) {
      api.createRecord('6f1b0e4c', component.options)
    } else {
      api.reload('6f1b0e4c', component.options)
    }
    module.hot.accept("./safetyHealthObliManage.vue?vue&type=template&id=6f1b0e4c", function () {
      api.rerender('6f1b0e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/obli/safetyHealthObliManage.vue"
export default component.exports